import { render, staticRenderFns } from "./exchange-item-card.vue?vue&type=template&id=3994dee5&scoped=true&lang=pug&"
import script from "./exchange-item-card.vue?vue&type=script&lang=js&"
export * from "./exchange-item-card.vue?vue&type=script&lang=js&"
import style0 from "./exchange-item-card.vue?vue&type=style&index=0&id=3994dee5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3994dee5",
  null
  
)

export default component.exports